import { getAuthIntegrations } from './config.js';
import { AuthIntegrationEvent } from './constants.js';
import { authenticate, deauthenticate } from './actions.js';

// (in future multiple auth integrations should be supported)

var integrations = getAuthIntegrations();

var onApiRequest = function onApiRequest(store, action) {
  var integration = integrations.getDefault();

  if (integration) {
    var event = integration.findEvent(AuthIntegrationEvent.ApiRequest);
    if (event) return event(store, action, authenticate, deauthenticate);
  }

  return Promise.resolve({});
};

var onMapAuthenticatedState = function onMapAuthenticatedState(result) {
  var integration = integrations.getDefault();

  if (integration) {
    var event = integration.findEvent(AuthIntegrationEvent.MapAuthenticatedState);
    if (event) return event(result);
  }

  return {
    loggedIn: true
  };
};

var onMapDeauthenticatedState = function onMapDeauthenticatedState(result) {
  var integration = integrations.getDefault();

  if (integration) {
    var event = integration.findEvent(AuthIntegrationEvent.MapDeauthenticatedState);
    if (event) return event(result);
  }

  return {
    loggedIn: false
  };
};

export { onApiRequest, onMapAuthenticatedState, onMapDeauthenticatedState };
